import { atom } from 'recoil';

export const TelecomTypeState = atom<number>({
  key: 'TelecomTypeState',
  default: 0,
});

export const PhoneNumberState = atom<string>({
  key: 'PhoneNumberState',
  default: '',
});

export const TransIdState = atom<string | null>({
  key: 'TransIdState',
  default: null,
});

export const CryptoNumberState = atom<string | null>({
  key: 'CryptoNumberState',
  default: null,
});

export const TimerState = atom<number>({
  key: 'TimerState',
  default: 180,
});
